<div>
    <div class="row">

        <div class="routes-1 opensans-semi-bold-sapphire-30px" >
            <span class="opensans-semi-bold-sapphire-30px" style="margin-left: 19px;" >Motivation</span>
            <div class="rectangle-210"></div>
        </div>
    </div>

    <form [formGroup]="form">
        <div class="col-md-12 p-0">
            <div class="col-sm-12 p-0" style="margin-top:2%; margin-bottom:10px; margin-left:0px">
                <h6>
                    <span style="padding-right:5px;  margin-bottom:5px;"></span>
                    Please provide a motivation for this particular service(s) <span style="color:lightgray">
                  </span>
                </h6>
                <div id="editor" class="cke_chrome">
                    <quill-editor  [disabled]="isAdmin" [styles]="{height: '400px'}" formControlName="motivation" 
                                  [modules]="quillConfig" [(ngModel)]="model.application.motivation_detail">
                    </quill-editor>
                </div>

                <!-- <ckeditor formControlName="motivation" debounce="500" [readonly]="!isProcess || (isDuplicate)" [(ngModel)]="model.application.motivation_detail">
                </ckeditor> -->
            </div>
        </div>
    </form>
</div>
<div class="col-12" *ngIf="!hideEdit && (isProcess || dataCntrl.status == '2')">
  <!-- <button class="btn btn-md m-clr pull-right hd-btn mt-2 ml-2" [disabled]="disableBtn" (click)="backToTab()"
          title="Back" style="float: left !important;">
    Back
  </button> -->
  <ng-container *ngIf="isProcess || dataCntrl.status == '2'">
    <div class="no-mp">
    <button *ngIf="utility.isView" title="Cancel"  (click)="cancelApplication()"  type="submit" id="btnSave" class="btn hd-btn-close">
      Close
    </button>
        <button  class="btn hd-btn ml-2" (click)="backToTab()" title="Back">Back</button>
              <button  *ngIf="isExternalRole" title="Save & Continue to step 4" (click)="saveMotivation()"   type="submit" id="btnSave" class="btn hd-btn">
      Next
    </button>

        <button *ngIf="!isExternalRole" title="Continue to step 3" (click)="goNextStep()"  type="submit" class="btn  hd-btn">
            Next
        </button>

  </div>
  <!-- <button class="btn btn-md m-clr pull-right hd-btn mt-2" [disabled]="disableBtn" (click)="cancelApplication()" title="Cancel" style="float: right !important;">Cancel</button>
  <button class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2"
          (click)="saveMotivation()" title="Save & Continueto step 5" [disabled]="disableBtn" style="float: right !important;">
     Save & Continue
  </button> -->
  </ng-container>
  <div *ngIf="disableBtn">
    <button class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2"
            routerLink="/permit/approval" title="Cancel" style="float: right !important;display: none;">
      <i class="fa fa-times"></i> Back
    </button>

  </div>
</div>
<div class="col-12 pull-right" *ngIf="hideEdit">

    <button  *ngIf="isExternalRole" title="Save & Continue to step 4" (click)="saveMotivation()"   type="submit" id="btnSave" class="btn hd-btn pull-right">
       Save Motivation
    </button>
</div>
<div class="col-12" *ngIf="pageload">
    <app-busy [message]="message"></app-busy>
</div>
